import $ from "jquery";
import { CookRankingsView } from "../view/cook_rankings_view";

class CookRankingsController {
  private form: Form;
  private view: any;

  constructor() {
    this.form = new Form();
    this.view = new CookRankingsView();
    this.view.initialize(this.form.invalidParameterCombinations());
    this.registerEventHandlers();
  }

  onLoad(): void {
    this.view.enableAllCsvButtons();
  }

  private registerEventHandlers(): void {
    this.view.onItemAspectChange((_aspect: any) => {
      this.form.submit();
    });
  }
}

class Form {
  formElement(): JQuery<HTMLElement> {
    return $("#rankings_form");
  }

  submit(): void {
    this.formElement().trigger("submit");
  }

  invalidParameterCombinations(): any {
    return this.formElement().data("invalidParameterCombinations");
  }
}

export { CookRankingsController };
